import { render, staticRenderFns } from "./editStudentGeneralDiary.vue?vue&type=template&id=1db00744&scoped=true"
import script from "./editStudentGeneralDiary.vue?vue&type=script&lang=js"
export * from "./editStudentGeneralDiary.vue?vue&type=script&lang=js"
import style0 from "./editStudentGeneralDiary.vue?vue&type=style&index=0&id=1db00744&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db00744",
  null
  
)

export default component.exports